import { Component, Inject, Renderer2 } from '@angular/core';
import {
  MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA,
  MatLegacySnackBarRef as MatSnackBarRef,
} from '@angular/material/legacy-snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Language } from 'src/app/core/enums/enums';
import { UtilsService } from 'src/app/core/services/utils.service';

@Component({
  selector: 'app-app-update-snack-bar',
  templateUrl: './app-update-snack-bar.component.html',
  styleUrls: ['./app-update-snack-bar.component.scss'],
})
export class AppUpdateSnackBarComponent {
  device: string;
  appStoreLinkEn =
    'https://apps.apple.com/us/app/kimbocare-mobile/id1617607005';
  appStoreLinkFr =
    'https://apps.apple.com/fr/app/kimbocare-mobile/id1617607005';
  playStoreLinkEn =
    'https://play.google.com/store/apps/details?id=com.kimbocare.kimboCareMobile&hl=en';

  playStoreLinkFr =
    'https://play.google.com/store/apps/details?id=com.kimbocare.kimboCareMobile&hl=fr';

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private _snackRef: MatSnackBarRef<AppUpdateSnackBarComponent>,
    private ren: Renderer2,
    private utilsService: UtilsService,
    private translateService: TranslateService
  ) {
    this.device = this.utilsService.getMobileOperatingSystem();
  }

  reload(): void {
    window.location.reload();
  }

  redirectToStore() {
    let linkToOpen: string;

    if (this.device === 'iOS') {
      linkToOpen =
        this.translateService.currentLang === Language.EN
          ? this.appStoreLinkEn
          : this.appStoreLinkFr;
      window.open(linkToOpen, '_blank');
    } else if (this.device === 'Android') {
      linkToOpen =
        this.translateService.currentLang === Language.EN
          ? this.playStoreLinkEn
          : this.playStoreLinkFr;
      window.open(linkToOpen, '_blank');
    } else {
      this.reload();
    }
  }

  dismiss() {
    this._snackRef.dismiss();
  }
}
